import { skipToken } from '@tanstack/react-query';
import { callRequest } from '../../helpers/callRequest';
import { autofillParams } from './autofillParams';
import { getInfiniteQueryKey } from './getQueryKey';
export const getUseWrappedInfiniteQuery = ({ request, wrapperOptions, getAutofill, getUseInfiniteQuery, }) => {
    const useWrappedInfiniteQuery = (queryOptions) => {
        const useInfiniteQuery = getUseInfiniteQuery();
        const queryKey = getInfiniteQueryKey(wrapperOptions, queryOptions.staticParams);
        const getQueryFn = () => {
            const { staticParams } = queryOptions;
            if (staticParams === skipToken)
                return skipToken;
            const queryFn = async (context) => {
                // It's there but the types don't want to collaborate with me
                const { pageParam } = context;
                const autofilledParams = autofillParams(queryOptions.getParams(staticParams, pageParam), getAutofill);
                const response = await callRequest(request, autofilledParams);
                return queryOptions.mapResponse({ pageParam, response });
            };
            return queryFn;
        };
        return useInfiniteQuery({
            ...queryOptions,
            queryKey,
            queryFn: getQueryFn(),
        });
    };
    return useWrappedInfiniteQuery;
};
